import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { CollectionsScreen } from "@/features/assets/components/CollectionsScreen";
import { normalizeAssetQuery } from "@/features/assets/queries";
import { useSearchField } from "@/features/assets/search-field";

interface CollectionsSearch {
  q?: string;
  /** Only the official collections; every public one when left out. */
  show?: "official";
}

export const Route = createFileRoute("/_authenticated/assets/collections/")({
  validateSearch: (search: Record<string, unknown>): CollectionsSearch => {
    const q = normalizeAssetQuery(search.q)?.slice(0, 80);
    return {
      ...(q && { q }),
      ...(search.show === "official" && { show: search.show }),
    };
  },
  head: () => ({ meta: [{ title: "Collections · Pax.co" }] }),
  component: CollectionsPage,
});

function CollectionsPage() {
  const { q, show } = Route.useSearch();
  const navigate = Route.useNavigate();
  const commitSearch = useCallback(
    (next: string | undefined) =>
      void navigate({
        search: previous => ({ ...previous, q: next }),
        replace: true,
        resetScroll: false,
      }),
    [navigate],
  );
  const [searchValue, setSearchValue] = useSearchField(q, commitSearch);

  return (
    <CollectionsScreen
      q={q}
      show={show ?? "all"}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      onShowChange={next =>
        void navigate({
          search: previous => ({ ...previous, show: next === "all" ? undefined : next }),
          replace: true,
        })
      }
    />
  );
}
